export enum AuditType {
  CompanyAccessAudit,
  OverrideStatusAudit
}
